<template>
  <div style="background:#fff">
    <div class="aui-book-head" v-if="title">
      <h2>{{title}}</h2>
      <!-- <span  v-if="showMore"  @click="showMoreAction" class="more">更多</span> -->
    </div>
    <div class="aui-list-theme" v-if="type =='history' && books">
      <router-link
        :to="{name: 'book-home', params: {id: book.bookInfo.bookId}}"
        v-for="book in books"
        :key="book.bookInfo.bookId"
        class="aui-list-theme-item shelf-item"
      >
        <div class="aui-list-img">
          <img :imgpath="getCoverPlaceholder(book.bookInfo.cover)"  v-lazy="require('../../assets/img/loading.jpeg')" alt />
        </div>
        <div class="aui-list-title">
          <h3>{{book.bookInfo.title}}</h3>
          <p>{{book.title}}</p>
        </div>
      </router-link>
    </div>
    <div class="aui-list-theme" v-if="type =='shelf'">
      <a
        @click="toBookDetail(book.bookId)"
        v-for="book in books"
        :key="book.bookId"
        class="aui-list-theme-item shelf-item"
      >
        <div class="aui-list-img">
          <img :imgpath="getCoverPlaceholder(book.cover)"  v-lazy="require('../../assets/img/loading.jpeg')" alt />
        </div>
        <div class="aui-list-title">
          <h3>{{book.title}}</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span>{{book.categoryName}}</span>
              <span  @click.stop="removeBook(book)" class="remove a">移除</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { getImg } from '../../services/urlService'

export default {
  name: 'books-shelf',
  props: {
    title: String,
    type: {
      type: String,
      default: 'history'
    },
    chapterTitle: String,
    books: Array,
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    getCover (route) {
      return getImg(`${route}_180_0.img`)
    },
    getCoverPlaceholder(route) {
      return `${route}_180_0.img`;
    },
    toBookDetail (id) {
      this.$router.isBack = false
      this.$router.push(`/book/${id}`)
    },
    removeBook (book) {
      this.$emit('remove-book', book)
    },
    showMoreAction () {
      this.$emit('show-more')
    },
    getPublishStatusText (code) {
      if (code === 'finish') {
        return '完结'
      } else {
        return '连载'
      }
    }
  },
  watch: {
    books (data) {}
  }
}
</script>

<style scoped>
</style>
